import React from "react";
import { Row, Col, Input, Select, Button } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";

const { Option } = Select;

const AssignmentFilters = ({
  searchText,
  onSearchChange,
  filterStatus,
  onStatusChange,
  filterTemplate,
  onTemplateChange,
  templates,
  onStudentsAssignment,
}) => {
  return (
    <>
      {/* Action Buttons Row */}
      <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={6}>
          <Button
            type="primary"
            icon={<UsergroupAddOutlined />}
            size="large"
            block
            onClick={onStudentsAssignment}
          >
            Students Assignment
          </Button>
        </Col>
      </Row>

      {/* Filters Row */}
      <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={8}>
          <Input
            placeholder="Search by BOTPC, student name or SPC..."
            allowClear
            size="large"
            value={searchText}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Select
            placeholder="Filter by template"
            allowClear
            size="large"
            style={{ width: "100%" }}
            onChange={onTemplateChange}
            value={filterTemplate}
          >
            {templates.map((template) => (
              <Option key={template.id} value={template.id}>
                {template.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Select
            placeholder="Filter by status"
            allowClear
            size="large"
            style={{ width: "100%" }}
            onChange={onStatusChange}
            value={filterStatus}
          >
            <Option value="Pending Selection">Pending Selection</Option>
            <Option value="Items Selected">Items Selected</Option>
            <Option value="Pending Payment">Pending Payment</Option>
            <Option value="Partially Paid">Partially Paid</Option>
            <Option value="Paid">Paid</Option>
            <Option value="Ready for Pickup">Ready for Pickup</Option>
            <Option value="Partially Collected">Partially Collected</Option>
            <Option value="Collected">Collected</Option>
            <Option value="Cleared">Cleared</Option>
            <Option value="Cancelled">Cancelled</Option>
          </Select>
        </Col>
      </Row>
    </>
  );
};

export default AssignmentFilters;
